skrilla.directive('userDetails', function () {
    return {
        templateUrl: 'directives/userDetails/userDetails.html',
        scope: {
            user: "=",
            refresh: "="
        },
        controller: function ($scope,
                              searchService,
                              objectChangeService,
                              countryService,
                              valuesToWordsService,
                              modalService,
                              profileTagService,
                              adminService,
                              currencyService,
                              queryService,
                              constantsService,
                              dateService,
                              validationService,
                              adminV2Service) {
            $scope.hasRole = adminService.hasRole;
            $scope.oldUsername = $scope.user.username;
            $scope.states = constantsService.getAustralianStates();
            $scope.tags = profileTagService.getTagsForDropdown();
            $scope.verificationStatuses = constantsService.getVerificationStatuses();
            $scope.key = "userDetails";
            objectChangeService.registerObject($scope.key, "user", $scope);
            $scope.hasChanged = objectChangeService.hasValueChanged;
            $scope.countries = countryService.getAllCountries();
            $scope.currencies = currencyService.getCurrencies()
            $scope.ipAddress = null;
            $scope.validate = {};

            $scope.cardVerificationStatus = 'UNKNOWN';
            $scope.testPermissions = function() {
                const queryString = queryService.getQueryString({
                    userId: $scope.user.id,
                    ipAddress: $scope.ipAddress
                })
                searchService.get("permissions/test" + queryString ).then(function (response) {
                    $scope.permissions = response.data;
                    $scope.cardVerificationStatus = $scope.permissions && $scope.permissions['withdraw_AUD'] ? $scope.permissions['withdraw_AUD'] : 'UNKNOWN';
                    $scope.cardVerificationRequired = $scope.cardVerificationStatus.startsWith('CC_UNVERIFIED')
                });
            }
            $scope.testPermissions()

            $scope.saveUser = function(){
                if(validateUser()) {
                    objectChangeService.confirmChanges($scope.key, "user").then(function (confirm) {
                        if (confirm === true) {
                            searchService.put('users/' + $scope.user.id, $scope.user, "Successfully updated user!").then(function (response) {
                                $scope.oldUsername = $scope.user.username;
                                $scope.user.eligibleForReverification = response.data.eligibleForReverification;
                                objectChangeService.registerObject($scope.key, "user", $scope);
                            }, function (response) {
                            });
                        }
                    });
                }
            }

            function validateUser() {
                const inputs = [
                    validationService.buildFieldValidationObj("firstName", !validationService.isEmpty($scope.user.firstName), "Please enter a first name"),
                    validationService.buildFieldValidationObj("lastName", !validationService.isEmpty($scope.user.lastName), "Please enter a last name"),
                    validationService.buildFieldValidationObj("postCode", !validationService.isEmpty($scope.user.postCode), "Please enter a post code"),
                ];
                return validationService.validateForm(inputs, $scope.validate)
            }


            $scope.updateMigration = function(){
                modalService.confirm("Are you sure you'd like to update this user's migration number?", function(){
                    searchService.put("users/" + $scope.user.id + "/migration/" + $scope.user.migration, null, "User migration successfully updated!").then(function(response) {
                        objectChangeService.registerObject($scope.key, "user", $scope);
                    });
                })
            }
            $scope.sync = function(){
                modalService.confirm("Are you sure you'd like to sync this user's data with external systems?", function(){
                    searchService.post("users/updates", {
                        actions: [],
                        users: [$scope.user.id]
                    }, "User  synced!").then(function(response) { });
                })
            }
            $scope.republishBets = function() {
                modalService.confirm("Are you sure you'd like to republish this user's bets?", function () {
                    searchService.post("users/updates", {
                        actions: ["Republish User Bets"],
                        users: [$scope.user.id]
                    }, "User  bets published!").then(function (response) {
                    });
                })
            }

            var autocomplete;
            var componentForm = {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                country: 'short_name',
                postal_code: 'short_name'
            };

            function initAutocomplete() {
                // Create the autocomplete object, restricting the search to geographical
                // location types.
                autocomplete = new google.maps.places.Autocomplete(
                    /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')),
                    {types: ['geocode']});

                // When the user selects an address from the dropdown, populate the address
                // fields in the form.
                autocomplete.addListener('place_changed', fillInAddress);
            }
            $scope.goV2 = function(){
                adminV2Service.openV2(`/users/${$scope.user.id}`)
            }

            function fillInAddress() {
                // Get the place details from the autocomplete object.
                var place = autocomplete.getPlace();

                for (var component in componentForm) {
                    document.getElementById(component).value = '';
                    document.getElementById(component).disabled = false;
                }

                // Get each component of the address from the place details
                // and fill the corresponding field on the form.
                for (var i = 0; i < place.address_components.length; i++) {
                    var addressType = place.address_components[i].types[0];
                    if (componentForm[addressType]) {
                        document.getElementById(addressType).value = place.address_components[i][componentForm[addressType]];
                        $scope.user[valuesToWordsService.getUserFieldFromGoogleMapsKey(addressType)] = place.address_components[i][componentForm[addressType]];
                    }
                }
            }
            setTimeout(function(){initAutocomplete()}, 500);
        }
    };
});
